import { getSettingValue } from './homepageHeroSettings.js';

export const DEFAULT_FAVICON_URL = '/favicon.svg';

export function getTenantFaviconUrl(tenant, fallbackValue = DEFAULT_FAVICON_URL) {
  const value = getSettingValue(tenant, 'tenant.favicon_url');
  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }
  const symbol = getSettingValue(tenant, 'branding.logo_variants')?.symbol;
  return typeof symbol === 'string' && symbol.trim() ? symbol : fallbackValue;
}

export function updateDocumentFavicon(faviconUrl = DEFAULT_FAVICON_URL, documentRef = document) {
  if (!documentRef?.head) return;

  const href = String(faviconUrl || '').trim() || DEFAULT_FAVICON_URL;
  let link = documentRef.querySelector('link[rel="icon"]');

  if (!link) {
    link = documentRef.createElement('link');
    link.setAttribute('rel', 'icon');
    documentRef.head.appendChild(link);
  }

  const lowerHref = href.toLowerCase();
  const type = lowerHref.endsWith('.svg')
    ? 'image/svg+xml'
    : lowerHref.endsWith('.ico')
      ? 'image/x-icon'
      : 'image/png';
  link.setAttribute('type', type);
  link.setAttribute('href', href);
}
